import { RumEvent, RumEventDomainContext } from "@datadog/browser-rum-slim";

export const jwtRedactor =
  (
    beforeSend: (
      event: RumEvent,
      context: RumEventDomainContext
    ) => void | boolean
  ) =>
  (event: RumEvent, context: RumEventDomainContext) => {
    switch (event.type) {
      case "view": {
        event.view.url = event.view.url.replace(/jwt=[^&]*/, "jwt=REDACTED");
        break;
      }
      case "resource": {
        event.resource.url = event.resource.url.replace(
          /jwt=[^&]*/,
          "jwt=REDACTED"
        );
        break;
      }
    }
    const result = beforeSend(event, context);
    return result;
  };
